/**
 * 新規登録 → 確認コードの間だけ、自動ログイン用のパスワードをメモリに保持する。
 * router の state（history.state）には載せない: ブラウザはセッション履歴をディスクに書くことがある。
 * リロードで消えるのは仕様で、そのときは確認後にログイン画面へ送る（spec §3.4）。
 */
let pending: { email: string; password: string } | null = null;

export const keepPendingPassword = (email: string, password: string): void => {
  pending = { email, password };
};

/** 同じ email なら 1 回だけ取り出せる。取り出したら消える */
export const takePendingPassword = (email: string): string | undefined => {
  if (!pending || pending.email !== email) {
    return undefined;
  }
  const { password } = pending;
  pending = null;
  return password;
};

export const clearPendingPassword = (): void => {
  pending = null;
};
